const RatingOnboardingCallout = () => {
  return (
    <div className="relative h-[59px] w-[218px] text-left">
      <svg
        aria-hidden="true"
        className="absolute inset-0"
        fill="none"
        height="59"
        viewBox="0 0 218.24 59"
        width="218"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect fill="white" height="50" rx="6" width="213" x="5.24" y="9" />
        <path
          d="M18 8.76795C19.3333 9.53775 19.3333 11.4623 18 12.2321L8.25 17.8612C6.91667 18.631 5.25 17.6688 5.25 16.1292L5.25 4.87084C5.25 3.33124 6.91667 2.36898 8.25 3.13878L18 8.76795Z"
          fill="white"
        />
      </svg>
      <p className="relative ml-[17px] w-[189px] pt-[17px] text-k/14_120 text-black">
        Past ratings show up when we rerun meals in the future.
      </p>
    </div>
  )
}

export default RatingOnboardingCallout
